import NosologyApi from './nosology.api';

class NosologyService {
  constructor() {
    this.api = new NosologyApi();
  }

  /**
   *  Метод для получения списка нозологий
   * @param {Object} params - Параметры запроса
   * @param {string} params.nosologyName - Строка поиска
   * @param {number} params.page - Номер страницы
   * @param {number} params.limit - Количество нозологий на странице
   * @returns
   */
  async getNosologyList(params) {
    return await this.api.getNosologyList(params);
  }


  /**
   *  Метод для получения короткого списка нозологий
   * @returns
   */
  async getShortNosologyList() {
    return await this.api.getShortNosologyList();
  }

  /**
   *  Метод для получения нозологии по ID
   * @param {string} id - ID нозологии
   * @returns
   */
  async getNosologyById(id) {
    return await this.api.getNosologyById(id);
  }

  /**
   *  Метод для создания нозологии
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование нозологии
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание нозологии
   * @returns
   */
  async createNosology(params) {
    return await this.api.createNosology(params);
  }

  /**
   *  Метод для удаления нозологии
   * @param {string} id - ID нозологии
   * @returns
   */
  async deleteNosology(id) {
    return await this.api.deleteNosology(id);
  }

  /**
   *  Метод для обновления нозологии
   * @param {string} id - ID нозологии
   * @param {Object} params - Параметры запроса
   * @param {string} params.name - Наименование нозологии
   * @param {Array} params.diagnoses - Массив диагнозов
   * @param {string} params.description - Описание нозологии
   * @returns
   */
  async updateNosology(id, params) {
    return await this.api.updateNosology(id, params);
  }
}

const nosologyService = new NosologyService();
export default nosologyService;
